import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

const EditableSelectCell = (listName) => ({ row, column: { accessor: key } }) => {
  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);

  const onChange = ({ target }) => {
    if (row[key] === target.value) {
      return;
    }

    row.editRow({ rowId: row.rowId, key, value: target.value, error });
  };

  const handleOnMouseDown = () => {
    row.handleSelectRow && row.handleSelectRow({ rowId: row.rowId });
  };

  return (
    <Select
      fullWidth
      className={row?.classes?.select}
      asteriskPosition="before"
      value={row[key]}
      onChange={onChange}
      onMouseDown={handleOnMouseDown}
      error={!!error}
      size="small"
    >
      {row[listName]?.map((option, index) => (
        <MenuItem key={option.value + index} value={option.value}>
          {row.translateString(option.label)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default EditableSelectCell;
